module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-fog2-2d387bdf.svg";